import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "need-consultation",
    data() {
        return {
            validationErrors: {},
        };
    },
    components: {},
    computed: {
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
    },
    destroyed() {},
};
